import {
  Directive,
  ElementRef,
  EventEmitter,
  inject,
  OnDestroy,
  OnInit,
  Output,
} from '@angular/core';
import { Subscription } from 'rxjs';
import { CaptchaService } from '../../services/captcha/captcha.service';

@Directive({
  selector: '[re-captcha]',
  standalone: false,
})
export class CaptchaDirective implements OnInit, OnDestroy {
  private readonly captchaService = inject(CaptchaService);
  private readonly elementRef = inject(ElementRef);

  private readonly subs = new Subscription();

  @Output() success = new EventEmitter<string>();
  @Output() error = new EventEmitter<string>();

  ngOnInit(): void {
    this.subs.add(
      this.captchaService.render(this.elementRef.nativeElement).subscribe({
        next: (token) => this.success.emit(token),
        error: (error: Error) => this.error.emit(error.message),
      }),
    );
  }

  ngOnDestroy(): void {
    this.subs.unsubscribe();
  }
}
